import type { ApiError } from "@/lib/api/client";
import { Alert } from "./Alert";
import { ApiFieldErrors } from "./ApiFieldErrors";

interface ApiErrorBannerProps {
  error: ApiError | Error | null | undefined;
  fieldLabels?: Record<string, string>;
  className?: string;
}

export function ApiErrorBanner({ error, fieldLabels, className = "" }: ApiErrorBannerProps) {
  if (!error) return null;

  return (
    <Alert variant="danger" className={className}>
      <ApiFieldErrors error={error} fieldLabels={fieldLabels} embedded />
    </Alert>
  );
}
